import apiService from './api-service';

const laporanService = {
  // ── Fetch data ─────────────────────────────────────────────────────────────

  getAll: async () => {
    try {
      const response = await apiService.get('/admin/laporan/export');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getPatientReport: async (params = {}) => {
    try {
      const response = await apiService.get('/admin/laporan/pasien', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getMedicalRecordReport: async (params = {}) => {
    try {
      const response = await apiService.get('/admin/laporan/rekam-medis', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getDoctorReport: async (params = {}) => {
    try {
      const response = await apiService.get('/admin/laporan/dokter', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  getRegistrationReport: async (params = {}) => {
    try {
      const response = await apiService.get('/admin/laporan/pendaftaran', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // ── Export PDF ─────────────────────────────────────────────────────────────

exportPatientPdf: async (params = {}) => {
  try {
    const response = await apiService.get('/admin/laporan/export/pdf', {
      params: {
        ...params,
        tipe: 'pasien', // 🔥 INI KUNCI NYA
      },
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
},
  exportMedicalRecordPdf: async (params = {}) => {
  try {
    const response = await apiService.get('/admin/laporan/export/pdf', {
      params: {
        ...params,
        tipe: 'rekam-medis', // 🔥 INI KUNCI NYA
      },
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
},

  exportRegistrationPdf: async (params = {}) => {
  try {
    const response = await apiService.get('/admin/laporan/export/pdf', {
      params: {
        ...params,
        tipe: 'pendaftaran', // 🔥 INI KUNCI NYA
      },
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
},
exportDoctorPdf: async (params = {}) => {
  try {
    const response = await apiService.get('/admin/laporan/export/pdf', {
      params: {
        ...params,
        tipe: 'dokter', // 🔥 INI KUNCI NYA
      },
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
},

};

export default laporanService;